import { IStore } from 'Store/.';
import { createSelector } from 'reselect';
import InnerSection from '../InnerSection/InnerSection';

const getIsFetchingSections = (store: IStore) => store.manualSeatPicker.isFetchingSections;
const getIsFetchingInnerSection = (store: IStore) => store.manualSeatPicker.isFetchingInnerSection;
const getIsFetchSectionsFailed = (store: IStore) => store.manualSeatPicker.isFetchSectionsFailed;
const getIsFetchInnerSectionFailed = (store: IStore) => store.manualSeatPicker.isFetchInnerSectionFailed;
const getSections = (store: IStore) =>  store.manualSeatPicker.sections;
const getInnerSection = (store: IStore) =>  store.manualSeatPicker.innerSection;
const getPriceCategories = (store: IStore) => store.manualSeatPicker.priceCategories;
const getReservationErrors = (state: IStore) => state.manualSeatPicker.reservationErrors;
const getIsReservationSuccessful = (state: IStore) => state.manualSeatPicker.isReservationSuccessful;
const getSelectedSeats = (state: IStore) => state.manualSeatPicker.selectedSeats;
const getHoveredSeats = (state: IStore) => state.manualSeatPicker.hoveredSeats;
const getNbrOfReservationsOnFetch = (state: IStore) => state.manualSeatPicker.nbrOfReservationsOnFetch;
const getIsFetchingReservations = (state: IStore) => state.manualSeatPicker.isFetchingReservations;

const getNbrOfRequestedSeats = (state: IStore) => (
  state.order.orderRequest.seatRequests.reduce((acc, val) => (
    acc + val.numberOfSeats
  ), 0)
);

const getSeatById = (state: IStore, seatID: number): Julius.Website.SectionSeatViewModel => {
  const foundSeat = state.manualSeatPicker.innerSection.seats.find(seat => {
    return seat.seatID === seatID;
  });
  if (!foundSeat) {
    return null;
  }
  return foundSeat;
}

const getIsFetching = createSelector(
  [getIsFetchingSections, getIsFetchingInnerSection],
  (isFetchingSections, isFetchingInnerSection) => {
    return isFetchingSections || isFetchingInnerSection;
  },
);

const getIsFetchFailed = createSelector(
  [getIsFetchSectionsFailed, getIsFetchInnerSectionFailed],
  (isFetchSectionsFailed, isFetchInnerSectionFailed) => {
    return isFetchSectionsFailed || isFetchInnerSectionFailed;
  },
);

const getVenueMinY = createSelector(
  [getSections],
  (sections) => { 
    if (!sections || !sections.length) {
      return null;
    }
    return sections.reduce((totalMin, section) => {
      const sectionMin = section.points.reduce((min, point) => point.y < min ? point.y : min, section.points[0].y);
      return sectionMin < totalMin ? sectionMin : totalMin;
    }, sections[0].points[0].y);
  },
);

const getVenueMinX = createSelector(
  [getSections],
  (sections) => { 
    if (!sections || !sections.length) {
      return null;
    }
    return sections.reduce((totalMin, section) => {
      const sectionMin = section.points.reduce((min, point) => point.x < min ? point.x : min, section.points[0].x);
      return sectionMin < totalMin ? sectionMin : totalMin;
    }, sections[0].points[0].x);
  },
);

const getAlignedSections = createSelector(
  [getSections, getVenueMinX, getVenueMinY],
  (sections, minX, minY) => {
    if (!sections || !sections.length) {
      return null;
    }
    return sections.slice().map(s => {
      s.points = s.points.slice().map(p => {
        p.x = p.x - minX + InnerSection.seatRadius*2;
        p.y = p.y - minY + InnerSection.seatRadius*2;
        return p;
      });
      return s;
    });
  },
);

const getNumberOfManualReservations = createSelector(
  [getSelectedSeats],
  (seats) => {
    return seats ? seats.length : 0;
  },
);

export {
  getIsFetching,
  getIsFetchFailed,
  getAlignedSections,
  getInnerSection,
  getPriceCategories,
  getReservationErrors,
  getIsReservationSuccessful,
  getNumberOfManualReservations,
  getSelectedSeats,
  getHoveredSeats,
  getNbrOfReservationsOnFetch,
  getSeatById,
  getNbrOfRequestedSeats,
  getIsFetchingReservations,
};


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/Redux/selectors.tsx